export default __webpack_public_path__ + "static/media/emerald_logo.2a11fb87.png";